import React, { useState } from "react";
import { Link } from "react-router-dom";
import appRoutes from "../../../routes/app.routes";
import { JOB_TABS, JOBS } from "../homeV2.constants";
import Reveal from "./Reveal";

const Jobs = () => {
  const [activeTab, setActiveTab] = useState(JOB_TABS[0]);

  return (
    <section className="home-v2__section hv2-jobs-section" id="jobs">
      <div className="home-v2__container hv2-jobs">
        <Reveal className="hv2-jobs__top">
          <h2 className="home-v2__h2">
            Opportunities worth <span className="home-v2__highlight">exploring</span>
          </h2>
          <Link to={appRoutes.candidateJobSearch.path} className="hv2-btn-text">
            Explore all jobs <span>→</span>
          </Link>
        </Reveal>

        <Reveal delay={0.08} className="hv2-jobs__tabs">
          {JOB_TABS.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`hv2-job-tab ${activeTab === tab ? "hv2-job-tab--active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </Reveal>

        <Reveal delay={0.16} className="hv2-jobs__grid">
          {JOBS.map((job) => (
            <Link to={appRoutes.candidateJobSearch.path} className="hv2-job-card" key={job.title}>
              <div className="hv2-job-card__company">
                <img src={job.logo} alt={job.company} className="hv2-job-card__logo" />
                {job.company}
              </div>
              <h4 className="hv2-job-card__title">{job.title}</h4>
              <div className="hv2-job-card__meta">{job.meta}</div>
              <div className="hv2-job-card__salary">{job.salary}</div>
              <div className="hv2-job-card__tags">
                {job.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
              <div className="hv2-job-card__view">View role →</div>
            </Link>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Jobs;
